var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappySmileGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2471_8352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "lightgray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 17.9034C10.3347 17.9034 8.75459 17.266 7.77289 16.1987C7.59181 16.0021 7.60465 15.6959 7.80125 15.515C7.99784 15.3341 8.3044 15.3467 8.48511 15.5435C9.28686 16.4153 10.6009 16.9356 11.9999 16.9356C13.399 16.9356 14.713 16.4153 15.5148 15.5435C15.6955 15.3467 16.0021 15.3341 16.1987 15.515C16.3953 15.6959 16.4081 16.0021 16.227 16.1987C15.2453 17.266 13.6651 17.9034 11.9999 17.9034Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93551 11.9997C7.40104 11.9997 6.96777 11.5664 6.96777 11.032V10.2578C6.96777 9.7233 7.40104 9.29004 7.93551 9.29004C8.46998 9.29004 8.90324 9.7233 8.90324 10.2578V11.032C8.90324 11.5664 8.46998 11.9997 7.93551 11.9997Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93549 9.29004C7.86921 9.29004 7.80452 9.29684 7.74194 9.30954V10.6449C7.74194 10.9655 8.00191 11.2255 8.32258 11.2255C8.64326 11.2255 8.90322 10.9655 8.90322 10.6449V10.2578C8.90322 9.72326 8.47001 9.29004 7.93549 9.29004Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0645 11.9997C15.5301 11.9997 15.0968 11.5664 15.0968 11.032V10.2578C15.0968 9.7233 15.5301 9.29004 16.0645 9.29004C16.599 9.29004 17.0323 9.7233 17.0323 10.2578V11.032C17.0323 11.5664 16.599 11.9997 16.0645 11.9997Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0645 9.29004C15.9982 9.29004 15.9335 9.29684 15.871 9.30954V10.6449C15.871 10.9655 16.1309 11.2255 16.4516 11.2255C16.7723 11.2255 17.0323 10.9655 17.0323 10.6449V10.2578C17.0323 9.72326 16.599 9.29004 16.0645 9.29004Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7419 22.258C7.1145 22.258 1.74192 16.8855 1.74192 10.258C1.74192 7.38802 2.75072 4.75439 4.43142 2.68945C1.72795 4.88977 0 8.24255 0 12C0 18.6274 5.37258 24 12 24C15.7575 24 19.1102 22.272 21.3106 19.5685C19.2456 21.2492 16.612 22.258 13.7419 22.258Z",
    fill: "lightgray"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2471_8352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappySmileGray);
export default __webpack_public_path__ + "static/media/happy-smile-gray.308eaf78a61d0fe935f9c2fcc235854f.svg";
export { ForwardRef as ReactComponent };